import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { MbscDatetimeOptions } from '@mobiscroll/angular';
import { RedirecFormService } from 'src/app/services/redirec-form.service';
import { SocketioService } from 'src/app/services/socket/socketio.service';
import { UserService } from 'src/app/services/user/user.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import * as alertifyjs from 'alertifyjs';
import { environment } from 'src/environments/environment';

/** While an upload is PENDING the list is refreshed on this interval, so the button unlocks by itself. */
const PENDING_POLL_MS = 5000;
/**
 * A PENDING upload older than this is taken as stuck (the process died before
 * marking it) and no longer locks the button. Above the slowest real upload.
 */
const STALE_PENDING_MS = 2 * 60 * 60 * 1000;

@Component({
  selector: 'app-carga-masiva-cupos-rewards',
  templateUrl: './carga-masiva-cupos-rewards.component.html',
  styleUrls: ['./carga-masiva-cupos-rewards.component.css']
})
export class CargaMasivaCuposRewardsComponent implements OnInit, OnDestroy {

  @ViewChild('fileInput', { read: ElementRef }) fileInput?: ElementRef<HTMLElement>;

  loadingXls:any;
  type:any = 'CARGA_MASIVA_CUPOS_REWARDS';
  fileName = '';
  formDataUpload:any = null;
  trace_documets:any  =[];
  loadingXls2:any;

  private pollTimer: ReturnType<typeof setInterval> | null = null;


  mobileSettingsFile: MbscDatetimeOptions = {
    display: 'bottom'
  };

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private _user: UserService,
    private sanitizer: DomSanitizer,
    private redirecFormService: RedirecFormService,
    public socketService: SocketioService,
    public _auth: AuthService
  ) { }

  ngOnInit(): void {
    this.getTrace_documets('CARGA_MASIVA_CUPOS_REWARDS');
  }

  ngOnDestroy(): void {
    this.stopPolling();
  }

  reload_noti(){
    return this.getTrace_documets('CARGA_MASIVA_CUPOS_REWARDS');
  }

  /** Some upload of this type (by any operator) is still being processed. */
  get uploadInProgress(): boolean {
    const now = Date.now();
    return (this.trace_documets || []).some((item: any) =>
      item?.state === 'PENDING' && now - new Date(item?.date_start).getTime() < STALE_PENDING_MS
    );
  }

  /** The button only sends a freshly selected file, never twice and never while an upload runs. */
  get canSubmit(): boolean {
    return !!this.formDataUpload && !this.loadingXls && !this.uploadInProgress;
  }

  onFileSelected  = async  (event:any) => {
    const file:File = event.target.files[0];
    if (file) {
        this.fileName = file.name;
        this.formDataUpload = file;
    }
  }


  submit = async () => {
    // A second click lands before the disabled state renders: guard here too.
    if (!this.canSubmit) return;
    this.loadingXls = true;
    const file = this.formDataUpload;
    // The file is spent once sent: another upload needs it selected again.
    this.clearSelectedFile();
    try {
      const formData = new FormData();
      formData.append("file", file);

      await this._user.bulk_cupo_rewards_upload(formData);

      alertifyjs.success(`Solicitud de aumento masivo de cupos con rewards exitosa`);
    } catch (error:any) {
      if(error.status == 400 ){
        alertifyjs.error(error.error.msg);
      }else{
        alertifyjs.error(`Error al enviar carga masiva de cupos con rewards`);
      }
    }
    // Unlock only once the list carries the new PENDING upload, so there is no gap.
    await this.reload_noti();
    this.loadingXls = false;

  }


  public getTrace_documets  = async (type:any) =>{
    try {
      try {

        let result = await this._user.traceDocumentsGet({type});

        this.trace_documets = result.resp;
      } catch (error) {
        console.log(error);


      }

    } catch (error) {

      this.loadingXls2 = false;


    }
    this.syncPolling();

  }


  dowloader_document(url:any){
    let url_f = `${environment.BASE_LA}/${url}`;
    window.open(`${url_f}`);
  }

  /**
   * Clears the selection, including the native input, so picking the same
   * file again fires `change`. The `change` dispatched here makes Mobiscroll
   * blank the file name it shows; `onFileSelected` ignores it (no file).
   */
  private clearSelectedFile(): void {
    this.formDataUpload = null;
    this.fileName = '';
    const input = this.fileInput?.nativeElement.querySelector('input[type="file"]') as HTMLInputElement | null;
    if (input) {
      input.value = '';
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  /** Polls the list while an upload is in progress; stops as soon as none is. */
  private syncPolling(): void {
    if (this.uploadInProgress && !this.pollTimer) {
      this.pollTimer = setInterval(() => this.reload_noti(), PENDING_POLL_MS);
    } else if (!this.uploadInProgress) {
      this.stopPolling();
    }
  }

  private stopPolling(): void {
    if (this.pollTimer) {
      clearInterval(this.pollTimer);
      this.pollTimer = null;
    }
  }


}
